import {
	type RelayError as ApolloErrorInterop,
	type RelayGraphQLError,
} from '@confluence/relay-errors/entry-points/RelayError.ts';

import {
	isFeedConfigDeletedSpaceError,
	isFeedConfigSpacePermissionError,
	isFeedConfigUserPermissionError,
} from '@confluence/activity-filter/entry-points/expectedGraphqlErrorHelpers.ts';

export const isExpectedApolloError = (error: ApolloErrorInterop): boolean => {
	return error.graphQLErrors.every(isExpectedGraphqlError);
};

const isExpectedGraphqlError = (error: RelayGraphQLError) => {
	return (
		isFeedConfigDeletedSpaceError(error) ||
		isFeedConfigSpacePermissionError(error) ||
		isFeedConfigUserPermissionError(error) ||
		isFeedDeletedCommentError(error) ||
		isFeedRecDeletedSpaceError(error) ||
		isSummaryLineUpdateUserPermissionError(error)
	);
};

const commentErrorPath = ['summaryLineUpdate', 'comment'];
// Deleted comment error for when the feed attempts to hydrate a deleted comment
const isFeedDeletedCommentError = (error: RelayGraphQLError) => {
	return (
		commentErrorPath.every((path) => error.path?.includes(path)) &&
		error.message?.includes('No comment found for the given id')
	);
};

const feedRecDeletedSpacePath = ['getRecommendedFeedUserConfig', 'recommendedSpaces', 'space'];
export const isFeedRecDeletedSpaceError = (error: RelayGraphQLError): boolean => {
	return (
		feedRecDeletedSpacePath.every((path) => error.path?.includes(path)) &&
		error.message.includes('Cannot find space with id')
	);
};

const summaryLineUpdateUserPath = ['feed', 'nodes', 'summaryLineUpdate', 'user'];
export const isSummaryLineUpdateUserPermissionError = (error: RelayGraphQLError): boolean => {
	return (
		summaryLineUpdateUserPath.every((path) => error.path?.includes(path)) &&
		error.message?.includes('User not permitted to access Confluence')
	);
};
